var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { AdminReservationBuilder } from './../builders/adminReservation-builder';
import { Injectable } from '@angular/core';
import { AdminReservationPremiumBuilder } from '../builders/adminReservationPremium-builder';
import { AuthenticatedApiService } from './authenticated-api.service';
import { ApiService } from './api.service';
import * as i0 from "@angular/core";
import * as i1 from "./authenticated-api.service";
import * as i2 from "./api.service";
export class AdminReservationApiService {
    constructor(api, unauthenticatedApi) {
        this.api = api;
        this.unauthenticatedApi = unauthenticatedApi;
    }
    get(id) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.api.get(`/adminreservations/${id}`).toPromise();
            return AdminReservationBuilder.buildAdminReservation(response.reservation);
        });
    }
    cancel(adminReservationID) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.api.post(`/adminreservations/cancel/${adminReservationID}`).toPromise();
            return AdminReservationBuilder.buildAdminReservation(response.reservation);
        });
    }
    restore(adminReservationID) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.api.post(`/adminreservations/restore/${adminReservationID}`).toPromise();
            return AdminReservationBuilder.buildAdminReservation(response.reservation);
        });
    }
    create(adminReservation) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.api.post(`/adminreservations`, adminReservation).toPromise();
            return AdminReservationBuilder.buildAdminReservation(response.reservation);
        });
    }
    update(adminReservation) {
        return __awaiter(this, void 0, void 0, function* () {
            const { id } = adminReservation;
            const response = yield this.api.put(`/adminreservations/${id}`, adminReservation).toPromise();
            return AdminReservationBuilder.buildAdminReservation(response.reservation);
        });
    }
    list(params) {
        return __awaiter(this, void 0, void 0, function* () {
            const payload = Object.assign({}, params);
            const response = yield this.api.get('/adminreservations/list', payload).toPromise();
            return AdminReservationBuilder.buildAdminReservationList(response);
        });
    }
    listPremium(params, id_lot) {
        return __awaiter(this, void 0, void 0, function* () {
            const payload = Object.assign({}, params);
            const response = yield this.api.get(`/adminreservations/premium_next_services/${id_lot}`, payload).toPromise();
            return AdminReservationPremiumBuilder.buildAdminReservationPremiumList(response);
        });
    }
    cancelCheckIn(adminReservationID) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.api.post(`/adminreservations/cancel_checkin/${adminReservationID}`).toPromise();
            return AdminReservationBuilder.buildAdminReservation(response.reservation);
        });
    }
    standardCheckin(id_reservation, params) {
        return __awaiter(this, void 0, void 0, function* () {
            const payload = Object.assign({}, params);
            const response = yield this.api.post(`/adminreservations/checkin/${id_reservation}`, payload).toPromise();
            return AdminReservationBuilder.buildAdminReservation(response.reservation);
        });
    }
    premiumRequest(params, adminReservationID) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.api.post(`/adminreservations/premium/${adminReservationID}`, params).toPromise();
            return AdminReservationBuilder.buildAdminReservation(response.reservation);
        });
    }
    premiumCancelRequest(reason, adminReservationID) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.api.post(`/adminreservations/premium_cancel/${adminReservationID}`, reason).toPromise();
            return AdminReservationBuilder.buildAdminReservation(response.reservation);
        });
    }
    premiumRequestUpdate(params, adminReservationID) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.api.put(`/adminreservations/premium/${adminReservationID}`, params).toPromise();
            return AdminReservationBuilder.buildAdminReservation(response.reservation);
        });
    }
    premiumAssignUserRequest(params, adminReservationID) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.api.post(`/adminreservations/premium_request/${adminReservationID}`, params).toPromise();
            return AdminReservationBuilder.buildAdminReservation(response.reservation);
        });
    }
    premiumQueueAssignUserRequest(params, adminReservationID) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.api.post(`/adminreservations/queuepremium/${adminReservationID}`, params).toPromise();
            return AdminReservationBuilder.buildAdminReservation(response.reservation);
        });
    }
    premiumUnassignUser(reason, adminReservationID) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.api.post(`/adminreservations/premium_unassign/${adminReservationID}`, reason).toPromise();
            return AdminReservationBuilder.buildAdminReservation(response.reservation);
        });
    }
    requestCheckout(id_reservation) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.api.post(`/adminreservations/checkout_request/${id_reservation}`).toPromise();
            return AdminReservationBuilder.buildAdminReservation(response.reservation);
        });
    }
    chargeReservation(id_reservation) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.api.post(`/adminreservations/charge_reservation/${id_reservation}`).toPromise();
            return AdminReservationBuilder.buildAdminReservation(response.reservation);
        });
    }
    standardCheckout(id_reservation, params) {
        return __awaiter(this, void 0, void 0, function* () {
            const payload = Object.assign({}, params);
            const response = yield this.api.post(`/adminreservations/checkout/${id_reservation}`, payload).toPromise();
            return AdminReservationBuilder.buildAdminReservation(response.reservation);
        });
    }
    sendReservationByEmail(id_reservation, params) {
        return __awaiter(this, void 0, void 0, function* () {
            const payload = Object.assign({}, params);
            const response = yield this.api.get(`/adminreservations/send_reservation_by_email/${id_reservation}`, payload).toPromise();
            return response;
        });
    }
    getReservationAvailavility(params) {
        return __awaiter(this, void 0, void 0, function* () {
            const payload = Object.assign({}, params);
            const response = yield this.api.post(`/adminreservations/availability`, payload).toPromise();
            return response;
        });
    }
    sendImageByEmail(params, id_image) {
        return __awaiter(this, void 0, void 0, function* () {
            const payload = Object.assign({}, params);
            const response = yield this.api.post(`/adminreservations/send_image_by_email/${id_image}`, payload).toPromise();
            return response;
        });
    }
    reservationRejectedReport(params) {
        return __awaiter(this, void 0, void 0, function* () {
            const payload = Object.assign({}, params);
            const response = yield this.api.get(`/adminreservations/reservation_rejected_report`, payload).toPromise();
            return response;
        });
    }
    reservationShuttleMode(id_reservation) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.unauthenticatedApi.get(`/adminreservations/shuttle_mode/${id_reservation}`).toPromise();
            return response;
        });
    }
    reservationDemoInstructions(params) {
        return __awaiter(this, void 0, void 0, function* () {
            const payload = Object.assign({}, params);
            const response = yield this.api.get('/adminreservations/instructions_test', payload).toPromise();
            return response;
        });
    }
    getRecurrencyReport(params) {
        return __awaiter(this, void 0, void 0, function* () {
            const payload = Object.assign({}, params);
            const response = yield this.api.get('/adminreservations/recurrency_report', payload).toPromise();
            return response;
        });
    }
    setWash(id_reservation, id_product_extra) {
        return __awaiter(this, void 0, void 0, function* () {
            const payload = { id_product_extra };
            const response = yield this.api.put(`/adminreservations/set_wash/${id_reservation}`, payload).toPromise();
            return AdminReservationBuilder.buildAdminReservation(response.reservation);
        });
    }
}
AdminReservationApiService.ɵfac = function AdminReservationApiService_Factory(t) { return new (t || AdminReservationApiService)(i0.ɵɵinject(i1.AuthenticatedApiService), i0.ɵɵinject(i2.ApiService)); };
AdminReservationApiService.ɵprov = i0.ɵɵdefineInjectable({ token: AdminReservationApiService, factory: AdminReservationApiService.ɵfac });
(function () { i0.ɵsetClassMetadata(AdminReservationApiService, [{
        type: Injectable
    }], function () { return [{ type: i1.AuthenticatedApiService }, { type: i2.ApiService }]; }, null); })();
//# sourceMappingURL=admin-reservation-api.service.js.map